import { FC, InputHTMLAttributes } from 'react';
import styled from 'styled-components';

const Container = styled.label(({ theme }) => {
  const { color, type } = theme.new;

  return `
    position: relative;
    display: inline-block;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    gap: 0.75rem;
    color: ${color.shade[2]};
    font-size: ${type.size[16]};
    font-weight: ${type.weight.regular};
    line-height: 1.44em;
    letter-spacing: 0.0025rem;
    cursor: pointer;
  `;
});

const Input = styled.input(({ theme }) => {
  const { color } = theme.new;

  return `
    position: absolute;
    left: -9000;
    top: 0;
    height: 1px;
    width: 1px;
    opacity: 0;

    & + span {
      border-radius: 4px;
      border: 2px solid ${color.neutral[6]};
      height: 1.5rem;
      width: 1.5rem;
      background-color: ${color.shade[1]};
      cursor: pointer;
      display: block;
    }

    &:checked + span {
      border-color: ${color.shade[2]};
      background-color: ${color.shade[2]};
      background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxNyAxMiI+CjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik02LjA5MjQgOC43NjcxMUM2LjQ4Mjk0IDkuMTU3NjQgNy4xMTYxNCA5LjE1NzYzIDcuNTA2NjUgOC43NjcwN0wxNS4yODQ3IDAuOTg4MTg0QzE1LjY3NTEgMC41OTc3MjEgMTYuMzA4MiAwLjU5NzcxNiAxNi42OTg4IDAuOTg4MDE5QzE3LjA4OTYgMS4zNzg1IDE3LjA4OTggMi4wMTE5OSAxNi42OTkyIDIuNDAyNjFMNy41MDY2NSAxMS41OTUxQzcuMTE2MTMgMTEuOTg1NyA2LjQ4Mjk2IDExLjk4NTcgNi4wOTI0NCAxMS41OTUxTDEuMTQyNTUgNi42NDUyNUMwLjc1MjA4MSA2LjI1NDc5IDAuNzUyMDgyIDUuNjIxNzIgMS4xNDI1NSA1LjIzMTI1QzEuNTMzMDEgNC44NDA3OSAyLjE2NjA4IDQuODQwNzkgMi41NTY1NSA1LjIzMTI1TDYuMDkyNCA4Ljc2NzExWiIvPgo8L3N2Zz4=");
      background-position: center;
      background-repeat: no-repeat;
      background-size: 70%;
    }

    &:focus-visible + span {
      outline: 2px auto -webkit-focus-ring-color;
    }
  `;
});

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
}

const Checkbox: FC<CheckboxProps> = ({ label, ...props }) => {
  return (
    <Container>
      <Input type="checkbox" {...props} />
      <span></span>
      {label}
    </Container>
  );
};

export default Checkbox;
